import React, {useState, useEffect} from "react";
import { useParams, useLocation } from 'react-router-dom';
import {Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Typography,
    Box,
    Link,
    CircularProgress
} from '@mui/material';

//  Components
import Logout from "./Navigation";
import Error from "./Error";

// API
import { fetchStudentActivities } from '../api/activity-service';

const columns = [
    { id: 'activityType', label: 'Activity Type', align: 'left', minWidth: 100 },
    { id: 'activityDate', label: 'Activity Date', align: 'left', minWidth: 100 },
    { id: 'videoName',    label: 'Video',         align: 'left', minWidth: 70 },
    { id: 'recordings',   label: 'Recordings',    align: 'left', minWidth: 70 },
]

const StudentActivity = () => {
    const params = useParams();
    const location = useLocation();

    const {studentUsername} = location.state || {};
    const [activity, setActivity] = useState([]);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    // Table params
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    useEffect(() => {
        // Get student's activities
        fetchStudentActivities(params.studentId).then(data => {
            // Sort by date in descending order
            data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            setActivity(data);
            setIsLoading(false);
        },
        error => {
            setIsLoading(false);
            setError(error.message)
        });
    }, []);

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(+e.target.value);
        setPage(0);
    };

    const convertDate = (date) => {
        let d = new Date(date);
        return d.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    };

    if (error) {
        return <Error message={error} />
    }

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                <CircularProgress></CircularProgress>
            </Box>
        )
    }

    return (
        <div>
            <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Link href={'/admin'}>Back</Link>
                <Logout />
            </Box>
            <Typography variant="h6" sx={{textAlign: 'center', marginBottom: 2}}>Activities for {studentUsername}</Typography>
            <Paper sx={{width: '80%', overflow: 'hidden', margin: 'auto'}}>
                <TableContainer sx={{maxHeight: '60vh'}}>
                    <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow sx={{borderBottom: 2}}>
                        {columns.map((column) => (
                            <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                            >
                            {column.label}
                            </TableCell>
                        ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { !activity.length ? <Typography sx={{textAlign: 'center'}}>No activities found</Typography> :
                        activity
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((a, i) => {
                            return (
                                <TableRow hover key={i}>
                                    <TableCell align="left">{a.activity_type}</TableCell>
                                    <TableCell align="left">{convertDate(a.created_at)}</TableCell>
                                    <TableCell align="left">{a.video_name}</TableCell>
                                    <TableCell align="left"></TableCell>
                                </TableRow>
                            )
                        })
                        }
                    </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={activity.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
};

export default StudentActivity;